<template>
	<div class="g-page flex">
		<div style="position: fixed; top: -100px;">
			<input type="text" name="username">
			<input type="password" name="password">
		</div>

		<div v-show="!windowPage" class="g-aside flex-column" :fold="asideFoldState">
			<div class="logo flex-column flex-center">
				<div class="logo-image">
					<img :src="saasInfo.saas_logo || require('@/assets/image/saas_logo.png')" alt="">
					<img :src="require('@/assets/image/icon.png')" alt="">
				</div>
				<p>{{saasInfo.saas_name}}</p>
			</div>
			<c-scroll class="menu flex-grow" bar-color="rgba(255,255,255,.5)">
				<dl v-for="(menu, i) in navList" :key="i" :ref="`menu-${i}`" class="item" :class="{'z-alive': aliveMenu == menu.menu_unique_key}" @mouseenter="menuMouseInHandle(menu, i)">
					<dt class="flex-center-cross" @click="navHandle(menu, menu)">
						<i class="icon tf" :class="`tf-nav-${menu.menu_unique_key}`"></i>
						<p class="flex-grow">{{menu.menu_name}}</p>
						<i v-if="menu.child_menu_list" class="angle tf-angle-right"></i>
					</dt>
					<dd v-if="menu.child_menu_list" :style="{'height': aliveMenu == menu.menu_unique_key && !asideFoldState ? `${menu.child_menu_list.length * 36 + 10}px` : 0}">
						<div :class="{'sub-menu': subMenuState}" :style="subMenuState ? subMenuStyle[menu.menu_unique_key] : ''">
							<c-scroll bar-color="rgba(255,255,255,.5)">
								<ul>
									<li v-for="(item, j) in menu.child_menu_list" :key="j" class="flex-center-cross" :class="{'z-alive': alivePage == item.menu_unique_key}" @mouseup="navHandle(item, menu, arguments[0])">
										<p>{{item.menu_name}}</p>
										<div v-if="item.window" class="window flex-center" title="新窗口打开"><i class="tf" @mouseup.stop="navHandle(item, menu, {which: 2})">&#xe639;</i></div>
									</li>
								</ul>
							</c-scroll>
						</div>
					</dd>
				</dl>
			</c-scroll>
			<div class="bottom flex-center">
				<p class="flex-grow">
				</p>
				<a class="flex-center" @click="asideFoldState = !asideFoldState"><i class="tf">&#xe6f9;</i></a>
			</div>
		</div>

		<div class="flex-grow flex-column">
			<div v-show="!windowPage" class="g-head flex">
				<div class="flex-grow flex-between-center">
					<div class="head-crumb flex-center">
						<template v-for="(item, i) in crumbList">
							<span v-if="i > 0"><i class="tf">&#xeb08;</i></span>
							<p>{{item}}</p>
						</template>
					</div>
						
					<div class="flex">
						<div v-for="(item, i) in headButtonList" :key="i" class="head-button" :active="activeHeadButton == item">
							<div class="head-button-main flex-center" @click.stop="headButtonHandle(item)">
								<i class="icon" :class="[item.icon]"></i>
								<span>{{item.name}}</span>
								<ins v-if="item.count" class="count">{{item.count}}</ins>
							</div>
							<ul v-if="item.list" class="head-button-list">
								<li v-for="(child, j) in item.list" :key="j" class="flex-center-cross" @click.stop="headButtonHandle(child)">{{child.name}}</li>
							</ul>
						</div>
						<div v-if="headButtonList.length" class="head-button-line"></div>
						<div class="user-info flex-center">
							<div class="icon flex-center">
								<img :src="userInfo.head_photo || require('@/assets/image/head_icon.jpg')" alt="">
							</div>
							<span class="name">{{userInfo.user_realname}}</span>
							<i class="tf-tri-down"></i>
							
							<div class="menu">
								<!-- <div class="item" @click="showUpdateLog">
									<span>更新日志</span>
									<div v-if="updateLogDot" class="dot"></div>
								</div> -->
								<div class="item" @click="$refs.resetPswForm.clear(); $refs.resetPsw.open()">修改密码</div>
								<div class="item" @click="logout">安全退出</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="g-content flex-grow">
				<router-view v-if="systemConfig" ref="routerView"></router-view>
			</div>
		</div>
		
		<c-dialog ref="updateLog" title="更新日志" width="900" height="680" button-name="关闭" :cancel-button="false">
			<div ref="updateLogList">
				<dl v-for="(item, i) in updateLog" :key="i" class="update-log">
					<dt class="flex-between-center">
						<p class="version">{{item.version}}</p>
						<p class="date">
							<i class="tf">&#xe678;</i>
							<span>{{item.update_time}}</span>
						</p>
					</dt>
					<dd>{{item.remark}}</dd>
				</dl>
			</div>
		</c-dialog>
		
		<c-dialog ref="resetPsw" title="修改密码" width="440" @resolve="resetPassword">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" required>
					<c-input type="password" name="old_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd" visible></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs, debounce} from '@deanwu/vue-component-library'
	import {mapState, mapGetters} from 'vuex'
	import getLodop from '@/assets/script/lodop.js'
	
	export default {
		name: 'Sys',

		components: {

		},

		props: {
			windowPage: Boolean
		},

		data() {
			return {
				asideFoldState: !!parseInt(localStorage.getItem('asideFoldState')),
				subMenuState: !!parseInt(localStorage.getItem('asideFoldState')),
				searchKeyword: '',
				showSearchList: false,
				searchList: [],
				aliveMenu: null,
				alivePage: null,
				subMenuStyle: {},

				crumbList: [],
				templateConfig: false,
				appViewConfig: false,
				activeHeadButton: null,

				printerError: '',

				updateLog: [],
				updateLogDot: false,

				pageButtonList: [],
				messageCount: 0
			}
		},
		
		computed: {
			...mapState(['saasInfo', 'userInfo', 'navList', 'systemConfig']),
			...mapGetters(['freeEdition']),
			
			headButtonList() {
				let arr = [];
				if (this.templateConfig) {
					arr.push({
						name: '模板管理',
						icon: 'tf-template',
						handle: () => {
							this.globalDialog('templateManage', {
								props: this.templateConfig
							})
						}
					});
				}

				if (this.appViewConfig) {
					let list = [];
					['extendView', 'detailView'].forEach(type => {
						if (this.appViewConfig[type]) {
							list = list.concat(
								this.appViewConfig[type].map(item => {
									let name = type == 'detailView' ? `详情-${item.name}` : item.name;
									return {
										name,
										handle: () => {
											this.globalDialog('appViewConfig', {
												props: item,
												data: {
													name,
													baseInfo: item.baseInfo === false ? false : true
												}
											})
										}
									}
								})
							)
						}
					});

					if (list.length && this.appViewConfig.viewId) {
						list.unshift({
							name: '列表卡片',
							handle: () => {
								this.globalDialog('appViewConfig', {
									props: this.appViewConfig,
									data: {
										name: '列表',
										baseInfo: this.appViewConfig.baseInfo === false ? false : true
									}
								})
							}
						});
					}

					arr.push({
						name: '移动端卡片管理',
						icon: 'tf-app-card',
						lock: this.lock(this.appViewConfig.auth),
						list: list.length ? list : null,
						handle: list.length ? null : () => {
							this.globalDialog('appViewConfig', {
								props: this.appViewConfig,
								data: {
									name: '列表',
									baseInfo: this.appViewConfig.baseInfo === false ? false : true
								}
							})
						}
					});
				}

				arr.push({
					name: '站内信',
					icon: 'tf-message',
					count: this.messageCount,
					handle: () => {
						this.navigateTo('/message')
					}
				});

				return this.pageButtonList.concat(arr);
			}
		},
		
		watch: {
			$route(val) {
				this.pageButtonList = [];
				this.parseRoute(val);
				if (val.name == '404') {
					this.aliveMenu = this.alivePage = null;
					return;
				};
				this.updateAlivePage();
			},

			'$route.name': {
				handler(val) {
					if (!this.$route.meta.authFree && this.lock(val)) {
						this.freeEditionTips(true);
					}
				},
				immediate: true
			},

			navList() {
				this.parseRoute();
				this.updateAlivePage();
			},

			asideFoldState(val) {
				localStorage.setItem('asideFoldState', val ? 1 : 0);

				if (val) {
					this._asideTimer = setTimeout(() => {
						this.subMenuState = true;
					}, 500);
				} else {
					clearTimeout(this._asideTimer);
					this.subMenuState = false;
				}

				clearTimeout(this._asideFoldEndTimer);
				clearInterval(this._asideFoldTimer);
				this._asideFoldTimer = setInterval(() => {
					if (this.$refs.routerView.$options.name == 'home') {
						this.$refs.routerView.resize();
					}
				}, 10);
				this._asideFoldEndTimer = setTimeout(() => {
					clearInterval(this._asideFoldTimer);
				}, 550);
			},
			
			searchKeyword() {
				this.searchHandle();
			}
		},
		
		created() {
			this.$store.dispatch('updateSystemConfig');
		},
		
		mounted() {
			this.parseRoute();
			this.updateAlivePage();
			window.addEventListener('click', () => {
				this.showSearchList = false;
				this.activeHeadButton = null;
			}, true);

			this.request({
				url: '/system/updateFlag',
				success: data => {
					this.updateLogDot = data;
				}
			});

			this.request({
				url: '/system/updateLog',
				data: {
					pageIndex: 1,
					pageSize: 1
				},
				success: ([data]) => {
					if (data && localStorage.getItem('versionNotice') != data.version) {
						localStorage.setItem('versionNotice', data.version);
						this.$notice({
							title: '新版本已上线',
							message: data.remark.split('\n').splice(0, 2).map(item => `<p class="ellipsis">${item}</p>`).join('') + '<p>...完整内容可打开更新日志查看</p>',
							button: [{
								name: '立即查看',
								callback: () => {
									this.showUpdateLog();
								}
							}, {
								name: '稍后查看'
							}]
						});
					}
				}
			});

			this.$refs.updateLogList.parentNode.addEventListener('scroll', () => {
				if (this._updateLogRequest) return;

				let list = this.$refs.updateLogList.getBoundingClientRect(),
					scroll = this.$refs.updateLogList.parentNode.getBoundingClientRect();
				
				if (list.bottom < scroll.bottom + 500) {
					this._updateLogPageIndex++;
					this.loadUpdateLog();
				}
			});

			!function messageCount() {
				this.request({
					url: '/message/count',
					success: data => {
						this.messageCount = data;
						this._messageTimer = setTimeout(() => {
							messageCount.call(this);
						}, 5000);
					}
				});
			}.call(this);

			// document.onreadystatechange = () => {
			// 	if (document.readyState == 'complete') {
			// 		getLodop().catch(e => {
			// 			this.printerError = e;
			// 		});
			// 	}
			// }

			const mapKey = [
				'c077efdc138ff78307d7fa9a84eeaf6e'
			];
			const script = document.createElement('script');
			script.src = `//api.tianditu.gov.cn/api?v=4.0&tk=${mapKey[Math.floor(Math.random() * (mapKey.length))]}`;
			document.head.appendChild(script);
		},

		beforeDestroy() {
			this._followRequest && this._followRequest.abort();
			clearTimeout(this._messageTimer);
		},
		
		methods: {
			menuMouseInHandle(menu, i) {
				if (this.asideFoldState) {
					let rect = this.$refs[`menu-${i}`][0].getBoundingClientRect();
					let height = menu.child_menu_list ? menu.child_menu_list.length * 36 + 20 : 0;
					let topHeight = window.innerHeight - rect.top - 20;
					let maxHeight = window.innerHeight - 40;
					this.$set(this.subMenuStyle, menu.menu_unique_key, {
						'top': (maxHeight < height ? 20 : topHeight < height ? rect.top - (height - topHeight) : rect.top) + 'px',
						'height': Math.min(height, maxHeight) + 'px'
					});
				}
			},

			navHandle(item, menu, e = {which: 1}) {
                var that = this;
                if (item.menu_unique_key == 'm_aftersale_bigdata') {
					window.open('/digital');
					return;
				}
				if (item.menu_unique_key == 'm_outlet_asset_bigdata') {
					window.open('/outlet_asset_digital');
					return;
				}

				if (![1, 2].includes(e.which)) return;

				if (!item.menu_unique_key) return;
				if (
					item == menu && (!this.asideFoldState || !item.child_menu_list)
					||
					item != menu && this.asideFoldState
				) {
					if (this.aliveMenu == menu.menu_unique_key) {
						this.aliveMenu = '';
					} else {
						this.aliveMenu = menu.menu_unique_key;
					}
				}

				if (item != menu || item.menu_unique_key == 'home') {
					if (e.which == 2) {
						this.windowTo({
							name: item.menu_unique_key
						});
					} else {
						this.alivePage = item.menu_unique_key;
						this.navigateTo({
							name: item.menu_unique_key
						});
					}
				}
                //记录常用功能
                if(item && item.menu_unique_key){
                    that.request({
                        url: '/home/common_func_add',
                        data: {
                            name: item.menu_name,
                            key: item.menu_unique_key
                        },
                        fail: () => {
                            return false;
                        }
                    });
                }
			},

			parseRoute(route = this.$route) {
				let crumb = [];
				!function loop(index, list) {
					let item = route.matched[index];
					if (!item) return;
					if (item.meta.title) {
						crumb.push(item.meta.title)
					} else if (list && item.name) {
						let menu = list.find(temp => temp.menu_unique_key == item.name);
						if (menu) {
							crumb.push(menu.menu_name);
							list = menu.child_menu_list;
						}
					}
					loop(++index, list);
				}(0, this.navList);
				this.crumbList = crumb;

				if (this.windowPage && crumb.length) {
					document.title = `${crumb[crumb.length - 1]} - 售后工单系统`;
				}

				if (route.meta.appView && this.auth(route.meta.appView.auth)) {
					this.appViewConfig = route.meta.appView;
				} else {
					this.appViewConfig = false;
				}

				if (route.meta.templateManage && (this.auth(route.meta.templateManage.print) || this.auth(route.meta.templateManage.export))) {
					this.templateConfig = route.meta.templateManage;
				} else {
					this.templateConfig = false;
				}
			},

			updateAlivePage(route = this.$route) {
				if (route.name == '404') {
					this.navigateTo('/');
					return;
				};

				this.alivePage = route.name;
				if (this.alivePage) {
					let menu = this.navList.find(menu => {
						return menu.child_menu_list && menu.child_menu_list.find(item => {
							return item.menu_unique_key == this.alivePage;
						});
					});
					menu && (this.aliveMenu = menu.menu_unique_key);
				}
			},
			
			searchHandle: debounce(function() {
				this.searchRequest && this.searchRequest.abort();
				
				if (this.searchKeyword) {
					this.searchRequest = this.request({
						url: '/system_menu/user_search',
						data: {
							menu_keyword: this.searchKeyword.trim()
						},
						success: data => {
							this.showSearchList = data.length > 0;
							this.searchList = data;
						}
					});
				} else {
					this.showSearchList = false;
					this.searchList = [];
				}
			}, 200),

			headButtonHandle(item) {
				if (item.lock) {
					this.freeEditionTips();
					return;
				}
				if (item.list) {
					this.activeHeadButton = item;
				} else {
					this.activeHeadButton = null;
				}
				item.handle && item.handle();
			},
			
			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
						old_pwd: '请填写旧密码',
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							message: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							message: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							type: 'success',
							message: '密码修改成功'
						});
						this.$refs.resetPsw.close();
					}
				});
			},

			showUpdateLog() {
				if (!this.updateLog.length) {
					this._updateLogPageIndex = 1;
					this.loadUpdateLog();
				}
				this.$refs.updateLog.open();
			},

			loadUpdateLog() {
				this._updateLogRequest = this.request({
					url: '/system/updateLog',
					data: {
						pageIndex: this._updateLogPageIndex
					},
					loading: this._updateLogPageIndex == 1,
					success: data => {
						if (data.length) {
							delete this._updateLogRequest;
						}
						this.updateLog = this.updateLog.concat(data);
					}
				});
			},

			setHeadButton(data) {
				this.pageButtonList = data.filter(item => this.auth(item.auth)).map(item => {
					item.lock = this.lock(item.auth);
					return item;
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-aside {
			z-index: 100;
			position: relative;
			width: 210px;
			background: #00A1E9;
			transition: width .5s ease;

			&[fold] {
				width: 60px;
			}
			
			.logo {
				position: relative;
				min-height: 90px;
				cursor: pointer;

				&-image {
					position: relative;
					height: 44px;
					pointer-events: none;
				
					img {
						max-width: none;
						height: 80%;
						opacity: 1;
						transition: opacity .2s ease;

						^[-3][fold] ^[-3..-1]:nth-child(1),
						^[-3]:not([fold]) ^[-3..-1]:nth-child(2) {
							opacity: 0;
						}

						&:nth-child(2) {
							position: absolute;
							left: 50%;
							top: 0;
							transform: translate(-50%,0);
						}
					}
				}

				p {
					margin-top: 10px;
					font-size: 16px;
					white-space: nowrap;
					color: #fff;
					opacity: 1;
					pointer-events: none;
					transition: opacity .2s ease;

					^[-2][fold] ^[-2..-1] {
						opacity: 0;
					}
				}

				span {
					position: absolute;
					left: 0;
					top: 0;
					border-radius: 0 12px 12px 0;
					padding: 0 9px 0 6px;
					line-height: 24px;
					font-size: 14px;
					font-weight: 500;
					white-space: nowrap;
				}
			}
			
			.menu {
				margin-top: 20px;

				.item {
					width: 210px;
					transition: background .3s ease, width .5s ease;

					&:nth-child(n+2) {
						margin-top: 5px;
					}

					^[-2][fold] ^[-2..-1] {
						width: 60px;

						&:hover {
							.sub-menu {
								display: block;
							}
						}
					}

					&.z-alive {
						background: #0089DB;
					}

					dt {
						height: 46px;
						padding: 0 18px 0 12px;
						overflow: hidden;
						color: #fff;
						opacity: .8;
						cursor: pointer;
						transition: all .2s ease;

						^[-3][fold] ^[-3..-1] {
							padding: 0 18px;
							color: #fff;
						}

						^[-3][fold] ^[-2..-2]:hover ^[-1..-1] {
							background: var(--color-main);
						}

						^[-3]:not([fold]) ^[-3..-1]:hover {
							opacity: 1;
						}
						
						^[-1].z-alive ^[-1..-1] {
							color: #fff;

							.angle {
								transform: rotate(90deg);
							}
						}
						
						.icon {
							width: 1em;
							font-size: 16px;
							text-align: center;

							^[-4][fold] ^[-3..-1] {
								min-width: 24px;
								font-size: 18px;
							}
						}

						p {
							margin: 0 12px;
							font-size: 14px;
							white-space: nowrap;
							opacity: 1;
							pointer-events: none;
							transition: opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}

						.angle {
							font-size: 13px;
							opacity: 1;
							pointer-events: none;
							transition: transform .3s ease, opacity .2s ease;

							^[-4][fold] ^[-3..-1] {
								opacity: 0;
							}
						}
					}
					
					dd {
						padding: 0 10px;
						overflow: hidden;
						transition: height .3s ease;
						
						^[-1].z-alive ^[-1..-1] {
							height: auto;
						}

						ul {
							padding-bottom: 10px;
						}
						
						li {
							position: relative;
							height: 36px;
							padding: 0 16px;
							font-size: 13px;
							white-space: nowrap;
							color: #eee;
							cursor: pointer;
							transition: all .3s ease;
							
							&:hover,
							&.z-alive {
								color: #00FFC5;
							}

							&:before {
								content: '';
								width: 5px;
								height: 2px;
								border-radius: 1px;
								margin-right: 10px;
								background: #eee;
								transition: all .2s ease;

								^[-1]:hover^[-1..-1],
								^[-1].z-alive^[-1..-1] {
									width: 12px;
									background: #00FFC5;
								}
							}

							.vip {
								height: 14px;
								margin-left: 8px;
							}

							.window {
								position: absolute;
								right: 0;
								top: 50%;
								border-radius: 50%;
								padding: 10px;
								font-size: 16px;
								color: #fff;
								transform: translate(0,-50%);

								&:hover {
									color: var(--color-main);
								}
							}
						}
					}
				}
			}

			.sub-menu {
				display: none;
				position: fixed;
				left: 60px;
				padding-left: 6px;
				animation: subMenuFadeIn .4s;
				
				@keyframes subMenuFadeIn {
					0% {
						opacity: 0;
						transform: translate(0,10px);
					}

					100% {
						opacity: 1;
						transform: translate(0,0);
					}
				}

				>>> .c-scroll {
					border-radius: 4px;
					background: #00A1E9;
				}

				ul {
					box-sizing: border-box;
					width: 180px;
					padding: 10px;
				}
			}

			.bottom {
				min-height: 40px;
				padding: 0 10px 0 18px;
				color: #fff;
				background: #009ADF;
				transition: padding .2s ease;

				^[-1][fold] ^[-1..-1] {
					padding: 0 15px;
				}

				p {
					height: 40px;
					overflow: hidden;
					font-size: 0;
					opacity: 1;
					transition: opacity .2s ease;

					img {
						max-width: none;
					}

					^[-2][fold] ^[-2..-1] {
						opacity: 0;
					}
				}

				a {
					width: 30px;
					height: 30px;
					font-size: 16px;
					opacity: .8;

					&:hover {
						opacity: 1;
					}

					^[-2][fold] ^[-2..-1] {
						transform: rotate(180deg);
					}
				}
			}
		}
		
		.g-head {
			z-index 50;
			position: relative;
			height: 50px;
			background: #fff;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);
			
			.search {
				position: relative;
				width: 360px;
				height: 34px;
				border-radius: 17px;
				margin-left: 25px;
				background: rgba(255,255,255,.2);
				
				.icon {
					margin: 0 8px 0 12px;
					color: #fff;
					opacity: .3;
				}
				
				input {
					height: 100%;
					padding-right: 15px;
					font-size: 13px;
				}
				
				ul {
					z-index: 99;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					max-height: 500px;
					border: 1px solid #eee;
					overflow: auto;
					background: #fff;
					box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
					
					li {
						padding: 6px 18px;
						font-size: 13px;
						color: #333;
						line-height: 24px;
						cursor: pointer;
					
						&:hover {
							background: #f5f5f5;
						}
						
						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}
						
						span {
							color: #999;
							
							.tf {
								margin-right: 5px;
							}
						}
					}
				}
			}

			.head-crumb {
				gap: 10px;
				padding-left: 20px;
				color: #999;

				p:nth-last-child(1) {
					color: #000;
				}
			}
			
			.head-button {
				position: relative;

				&:nth-child(n+2) {
					margin-left: 20px;
				}

				&-main {
					position: relative;
					height: 50px;
					font-size: 13px;
					color: #444;
					cursor: pointer;

					^[-1]:hover ^[-2..-1],
					^[-1][active] ^[-2..-1] {
						color: var(--color-main);
					}

					.icon {
						font-size: 16px;

						+ span {
							margin-left: 6px;
						}
					}

					.count {
						position: absolute;
						left: 8px;
						bottom: 50%;
						box-sizing: border-box;
						min-width: 14px;
						border-radius: 7px;
						padding: 0 2px;
						line-height: 14px;
						font-size: 11px;
						text-align: center;
						color: #fff;
						background: #f00;
					}

					.error {
						position: absolute;
						left: 8px;
						top: 12px;
						font-size: 12px;
						color: #f00;
					}

					.vip {
						height: 14px;
						margin-left: 4px;
					}
				}

				&-list {
					display: none;
					z-index: 90;
					position: absolute;
					left: 0;
					top: 100%;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1][active] ^[-1..-2] {
						display: block;
					}

					li {
						height: 36px;
						padding: 0 16px;
						white-space: nowrap;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}

						&:hover {
							color: var(--color-main);
						}
					}
				}

				&-service {
					display: none;
					z-index: 90;
					position: absolute;
					left: -20px;
					top: 100%;
					box-sizing: border-box;
					width: 160px;
					padding: 12px 0;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1]:hover ^[-1..-2] {
						display: block;
					}

					li {
						position: relative;
						padding: 0 20px;
						white-space: nowrap;
						line-height: 36px;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:hover {
							color: var(--color-main);
						}

						.mobile {
							display: none;
							position: absolute;
							left: 100%;
							top: 0;
							box-sizing: border-box;
							border: 1px solid #ddd;
							line-height: initial;
							font-size: 0;
							background: #fff;

							^[-1]:hover ^[-1..-1] {
								display: block;
							}

							.qrcode {
								width: 130px;
								max-width: none;
								height: 130px;
							}

							p {
								padding-bottom: 5px;
								line-height: 22px;
								font-size: 12px;
								text-align: center;
								color: #666;

								span {
									color: #f55;
								}
							}
						}
					}
				}

				&-line {
					width: 1px;
					height: 50px;
					margin: 0 15px;
					background: linear-gradient(0deg, #FFFFFF, #DDDDDD, #FFFFFF);

					+ .head-button {
						margin-left: 0;
					}
				}
			}

			.head-ai {
				height: 50px;
				margin-left: 25px;
				cursor: pointer;

				img {
					height: 20px;
					transition: transform .1s ease;

					^[-1]:hover ^[-1..-1] {
						transform: scale(1.2);
					}
				}
			}
			
			.user-info {
				z-index: 100;
				position: relative;
				height: 50px;
				padding: 0 20px;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover {
					.menu {
						display: block;
					}
				}
				
				.icon {
					width: 34px;
					height: 34px;
					border-radius: 100%;
					overflow: hidden;
					background: #F5F5F5;
				}
				
				.name {
					margin: 0 6px 0 10px;
					font-size: 13px;
				}
				
				> .tf {
					font-size: 12px;
				}
				
				.menu {
					display: none;
					z-index: 12;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					border: 1px solid #eee;
					padding: 8px 0;
					color: #000;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);
					
					.item {
						position: relative;
						padding: 0 10px 0 16px;
						line-height: 36px;
						font-size: 13px;
						color: #333;
						
						&:hover {
							color: var(--color-main);
						}
						
						.dot {
							position: absolute;
							right: 20px;
							top: 50%;
							width: 6px;
							height: 6px;
							border-radius: 100%;
							background: #f00;
							transform: translate(0, -50%);
						}
					}
				}
			}
		}
		
		.g-content {
			overflow: auto;
			background: #F5F4F7;
		}
	}

	.update-log {
		margin: 10px 20px;

		dt {
			height: 50px;

			.version {
				font-size: 18px;
				font-weight: bold;
				color: var(--color-main);
			}

			.date {
				font-size: 13px;
				color: #999;

				.tf {
					margin-right: 6px;
				}
			}
		}

		dd {
			border-radius: 8px;
			padding: 20px 24px;
			line-height: 22px;
			font-size: 14px;
			white-space: pre-wrap;
			color: #333;
			background: #F9F9F9;

			^[-1]:nth-child(1) ^[-1..-1] {
				color: #01A27D;
				background: #F1FAF8;
			}
		}
	}

	.help-doc {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
	}

	.service-code {
		padding: 30px 0 20px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 20px;
			font-size: 16px;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 18px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}
	}

	.custom-service {
		padding: 30px 0 18px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 12px;
			font-size: 22px;
		}

		h2 {
			width: 310px;
			margin-top: 10px;
			line-height: 20px;
			font-size: 13px;
			font-weight: normal;
			text-align: center;
			color: #666;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 20px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}

		.tel {
			gap: 10px;
			width: 340px;
			height: 50px;
			border-radius: 6px;
			margin-top: 16px;
			font-size: 22px;
			color: #fff;
			background: var(--color-main);
		}
	}

	.follow {
		h1 {
			padding: 50px 0 30px;
			font-size: 26px;
			
			span {
				color: var(--color-main);
			}
		}

		&-code {
			width: 500px;
			height: 260px;
			border-radius: 16px 16px 0 0;
			background: linear-gradient(0deg, #6BE7CB, #00A27D);

			img {
				width: 186px;
				height: 186px;
				border-radius: 4px;
			}
		}

		&-rights {
			box-sizing: border-box;
			width: 500px;
			border-radius: 0 0 16px 16px;
			padding: 10px 40px;
			background: #EFF6F4;

			div {
				gap: 8px;
				width: 50%;
				height: 28px;
				font-size: 13px;
				color: #3D9A85;
			}
		}

		&-bottom {
			gap: 10px;
			padding: 20px 0 40px;

			.tf {
				font-size: 26px;
				color: #00CF5D;
			}

			p {
				font-size: 18px;
				font-weight: bold;
			}
		}
	}
</style>
